import { LEVELS, levelFor } from "@/lib/framework";

export function LevelBadge({ score, level, className = "", size = "sm", testId }) {
  const lv = level ? LEVELS.find((l) => l.id === level) : levelFor(score);
  const pad = size === "lg" ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${pad} ${lv.badge} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: lv.hex }} />
      {lv.name}
    </span>
  );
}
